import React from 'react';
import { Person } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useMsal, useAccount } from '@azure/msal-react';
import { useGetTicketsCreatedByQuery } from '../../../../services/TicketService';
import { countActiveTickets } from '../../utils';
import MetricCard from '../MetricCard';

/**
 * MyTicketsCard - Displays count of tickets created by the current user
 * Excludes closed/cancelled tickets to show only active requests
 */
const MyTicketsCard: React.FC = () => {
  const navigate = useNavigate();
  const { accounts } = useMsal();
  const account = useAccount(accounts[0] || {});
  
  // Get user's created tickets
  const { data: myTickets = [], isLoading: myTicketsLoading } = useGetTicketsCreatedByQuery(
    { customerName: account?.name || '' },
    { skip: !account?.name }
  );

  const myTicketsCount = countActiveTickets(myTickets);

  const handleClick = () => {
    if (account && account.name) {
      navigate(`/tickets/my-tickets?createdBy=${encodeURIComponent(account.name)}`);
    } else {
      navigate('/tickets/my-tickets');
    }
  };

  return (
    <MetricCard
      title="My Tickets"
      value={myTicketsCount}
      icon={Person}
      color="#3b82f6"
      loading={myTicketsLoading}
      onClick={handleClick}
      subtitle="Created by me"
    />
  );
};

export default MyTicketsCard;